import { configureStore } from '@reduxjs/toolkit';
import userWebLayoutReducer from './userWebLayout/userWebLayoutSlice';
import finderReducer from './Finder/finderSlice';
import categoryColorsReducer from './categoryColors/categoryColorsSlice';
//import { logger } from './middleware/logger';

export const store = configureStore({
    reducer: {
        userWebLayout: userWebLayoutReducer,
        finder: finderReducer,
        categoryColors: categoryColorsReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            // Ignore async thunk arguments which may contain non-serializable values
            // This is necessary because async thunks pass API instances and other non-serializable values
            ignoredActionsPaths: ['meta.arg'],
            // Temporarily ignore userWebLayout.appInfos to allow cleanup of legacy data
            // All new data is now properly serialized via ensureSerializable in userWebLayoutSlice
            ignoredPaths: ['userWebLayout.appInfos'],
            // Enable in development - will warn after 32ms of checking
            // This helps identify non-serializable values without breaking the app
            warnAfter: 32,
        },
        immutableCheck: {
            // Enable immutability checks in development
            // This will warn about direct state mutations
            warnAfter: 32,
        }
    }),
    devTools: process.env.NODE_ENV !== 'production'
    //.concat(logger)    
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;